import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { giftCardMobx, decorationMobx } from '@mobxStore'
import { useHistoryNew } from '@utils'
import { find } from '@dt/fe-utils/dist/lodash'
import { CardShape } from 'pages/mkt/components'
import './index.scss'

interface IProps { }

const GiftCardAct: FC<IProps> = () => {
  const history = useHistoryNew()
  const { eGiftCardList } = giftCardMobx
  const { mktDecorates } = decorationMobx
  let info: any = find(mktDecorates.market, (item: any) => item.key === 'giftCard')
  if (!info) {
    info = find(mktDecorates.notMarket, (item: any) => item.key === 'giftCard') || {}
  }
  const handleGo = (path) => {
    history.push(path)
  }
  return (
    <div className='giftcard-panel'>
      {
        !info.hideTitle &&
          <div className='panel-header'>
            <div className='title'>{i18n.t('common.GiftCard')}</div>
          </div>
      }
      <div className='panel-content'>
        {
          eGiftCardList.slice(0, info.showCnt === 'all' ? eGiftCardList.length : parseInt(info.showCnt)).map((item: any) => {
            const shape = item.covers && item.covers[0]?.shapes ? item.covers[0].shapes[0] : 'rectangle'
            return (
              <div
                data-cypid='mmgToBuyGCard'
                className={`card-info ${info.showCnt === '1' || eGiftCardList.length === 1 ? `one ${shape}` : ''}`} key={item.giftcardId} onClick={(e: any) => handleGo(`/giftCard/buy/${item.giftcardId}`)}
              >
                <div className='card-img'>
                  <CardShape cardFace={item.covers && item.covers[0] ? item.covers[0]?.url : ''} border='none' shape={shape} isScale={!(info.showCnt === '1' || eGiftCardList.length === 1)}></CardShape>
                </div>
                {
                  !info.hideName && <div className='card-desc'>{item.giftcardName}</div>
                }
              </div>
            )
          })
        }
      </div>
      <div className='panel-footer'>
        <div data-cypid='mmgToGCardList' className='btn' onClick={(e: any) => handleGo('/giftCard/2')}>{i18n.t('mkt.giftCard.viewAllGiftCards')}</div>
      </div>
    </div>
  )
}

export default observer(GiftCardAct)
